import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.9832 20.988L5.56923 19.162L4.13623 3.01196H19.8652L18.4362 19.162L11.9832 20.988ZM7.69123 13.297L7.93623 16.42L11.9992 17.505L16.0272 16.425L16.5862 10.312H9.40223L9.22923 8.27896H16.7622L16.9362 6.31796H7.06623L7.58823 12.318H14.4242L14.1812 14.884L12.0022 15.484L9.78623 14.877L9.64523 13.297H7.69123Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Html5"
);
